import React from 'react';
import Breadcrumb from '../components/Common/Breadcrumb';

const Testimonial = () => {
  const testimonials = [
    {
      id: 1,
      name: 'John Doe',
      position: 'Business Owner',
      image: '/assets/img/testimonial-1.jpg',
      text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat deleniti amet at atque sequi quibusdam cumque itaque repudiandae temporibus.'
    },
    {
      id: 2,
      name: 'Jane Smith',
      position: 'Student',
      image: '/assets/img/testimonial-2.jpg',
      text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat deleniti amet at atque sequi quibusdam cumque itaque repudiandae temporibus.'
    },
    {
      id: 3,
      name: 'Mike Johnson',
      position: 'Professional',
      image: '/assets/img/testimonial-3.jpg',
      text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat deleniti amet at atque sequi quibusdam cumque itaque repudiandae temporibus.'
    },
    {
      id: 4,
      name: 'Sarah Wilson',
      position: 'Entrepreneur',
      image: '/assets/img/testimonial-1.jpg',
      text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat deleniti amet at atque sequi quibusdam cumque itaque repudiandae temporibus.'
    },
    {
      id: 5,
      name: 'David Brown',
      position: 'Engineer',
      image: '/assets/img/testimonial-2.jpg',
      text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat deleniti amet at atque sequi quibusdam cumque itaque repudiandae temporibus.'
    },
    {
      id: 6,
      name: 'Emily Davis',
      position: 'Doctor',
      image: '/assets/img/testimonial-3.jpg',
      text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat deleniti amet at atque sequi quibusdam cumque itaque repudiandae temporibus.'
    }
  ];

  return (
    <>
      <Breadcrumb title="Testimonials" />
      <div className="container-fluid testimonial py-5">
        <div className="container py-5">
          <div className="section-title text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
            <div className="sub-style">
              <h5 className="sub-title text-primary px-3">Testimonial</h5>
            </div>
            <h1 className="display-5 mb-4">What Our Clients Say</h1>
            <p className="mb-0">Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat deleniti amet at atque sequi quibusdam cumque itaque repudiandae temporibus.</p>
          </div>
          <div className="row g-4">
            {testimonials.map((testimonial, index) => (
              <div key={testimonial.id} className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay={`${0.1 + index * 0.2}s`}>
                <div className="testimonial-item text-center p-4">
                  <div className="testimonial-img mb-4">
                    <img src={testimonial.image} className="img-fluid rounded-circle" alt={testimonial.name} />
                  </div>
                  <div className="testimonial-content">
                    <p className="mb-4">{testimonial.text}</p>
                    <h5 className="mb-1">{testimonial.name}</h5>
                    <span className="text-muted">{testimonial.position}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Testimonial; 